export default "https://cdn-static.gokick.com/assets/1efca0ef19d403b8805a53d90e225e0b5d561c25/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";